import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { FeatureDisabledProblem } from '../models/feature-flag.model';
import { FeatureFlagService } from './feature-flag.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private router: Router
  ) {}
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authService = this.injector.get(AuthService);
    const token = authService.getToken();
    const hasValidSession = token ? authService.isAuthenticated() : false;
    const headers: Record<string, string> = { 'Accept': 'application/json' };

    // Let the browser add the multipart boundary for file uploads.
    if (!(req.body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }

    if (token && hasValidSession) {
      headers['Authorization'] = token.toLowerCase().startsWith('bearer ')
        ? token
        : `Bearer ${token}`;
    }

    // Clone the request and add headers if needed
    const modifiedReq = req.clone({
      setHeaders: headers
    });
    
    return next.handle(modifiedReq).pipe(
      catchError(error => {
        const problem = error?.error as FeatureDisabledProblem | undefined;
        if (
          error instanceof HttpErrorResponse
          && error.status === 403
          && problem?.title === 'Feature currently unavailable'
          && typeof problem.featureKey === 'string'
        ) {
          this.injector.get(FeatureFlagService).invalidateFeature(problem.featureKey, problem);
        }
        const isPublicRequest = req.url.includes('/api/public/');
        if (error instanceof HttpErrorResponse && error.status === 401 && !isPublicRequest) {
          authService.logout();
          this.router.navigate(['/login'], {
            queryParams: { sessionExpired: true }
          });
        }

        return throwError(() => error);
      })
    );
  }
}
